module.exports = __webpack_public_path__ + "7160e85676038a939e6f080369cded7f.pdf";